<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name: 'Home' }">
        Mon compte
      </el-breadcrumb-item>

      <el-breadcrumb-item v-if="!!gpp">
        {{ gpp.euTitle }}
      </el-breadcrumb-item>
    </el-breadcrumb>

    <el-row
      v-if="underMaintenance"
      type="flex"
    >
      <el-alert
        :closable="false"
        effect="dark"
        show-icon
        title="Maintenance"
        type="info"
      >
        Nos services sont momentanément indisponibles en raison d'activité de maintenance.<br>
        Le site sera à nouveau accessible dans quelques heures.
      </el-alert>
    </el-row>

    <template v-if="!!gpp">
      <el-dialog
        title="Voulez-vous vraiment supprimer cette participation ?"
        :visible.sync="modals.remove.show"
        class="gpp-dialog"
      >
        <p class="modals-remove-text">
          Votre participation ainsi que les votes que vous avez reçus seront définitivement supprimés.
        </p>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="modals.remove.show = false">
            Annuler
          </el-button>
          <el-button
            type="danger"
            :loading="saving"
            @click="remove"
          >
            Supprimer cette participation
            <i class="modals-remove-button-delete-icon el-icon-delete el-icon-right" />
          </el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="Partager ma participation"
        :visible.sync="modals.share.show"
        class="gpp-dialog"
      >
        <div class="modals-share-content">
          <div class="modals-share-content-icons">
            <el-tooltip
              content="Facebook"
              placement="top"
            >
              <a
                target="popup"
                :href="`https://www.facebook.com/sharer/sharer.php?u=${encodedParticipationLink}`"
                @click="openFacebookShareModal"
              >
                <img
                  src="/img/icons/share/fb.png"
                  alt="Partager sur Facebook"
                >
              </a>
            </el-tooltip>
            <el-tooltip
              content="E-mail"
              placement="top"
            >
              <a
                target="_blank"
                :href="
                  `mailto:` +
                    `?subject=${encodeURI('Vote pour ma photo sur verdie.voyages.com')}` +
                    `&body=${encodeURI('Je participe au Grand Prix Photo VERDIÉ VOYAGES ! Je t’invite dès à présent à voter pour ma photo en cliquant ici : ' + participationLink + '  !')}`"
              >
                <img
                  src="/img/icons/share/email.png"
                  alt="Partager par E-Mail"
                >
              </a>
            </el-tooltip>
          </div>
          <span class="el-dialog__title">Copier le lien vers la participation</span>
          <el-form class="copy-url-form">
            <el-form-item>
              <el-input
                ref="input"
                class="copy-url-input"
                :value="participationLink"
                readonly
                @focus="(evt) => evt.target.select()"
              />
              <el-tooltip
                content="Copier le lien vers la participation"
                placement="top"
              >
                <el-button
                  v-clipboard:copy="participationLink"
                  v-clipboard:success="() => {
                    $refs.input.select()
                    $message({
                      duration: 5000,
                      message: 'Lien vers la participation copié dans le presse-papier',
                      showClose: true,
                      type: 'info'
                    })
                  }"
                  type="primary"
                >
                  Copier
                </el-button>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <el-card>
        <template #header>
          <div class="gpp-header-wrapper">
            <span>{{ gpp.euTitle }}</span>
            <span>
              <el-link
                :href="gppLink"
                target="_blank"
                type="primary"
                class="participation-link"
              >
                Voir toutes les participations
                <i class="el-icon-right el-icon--right" />
              </el-link>
            </span>
          </div>
        </template>
        <el-row class="gpp-intro-wrapper">
          <el-col :span="24">
            <span class="gpp-intro-text">
              Vous avez pris de belles photos lors d’un voyage Verdié, en France ou à l’autre bout du monde ?<br>
              Participez au Grand Prix Photo Verdié Voyages en soumettant votre cliché via le formulaire ci-dessous (rappel : une seule photo par participant et par compte client).<br>
              Une fois votre participation enregistrée vous pourrez, pendant toute la durée du jeu, venir dans cet espace la modifier, la supprimer ou la remplacer par une autre.
            </span>
          </el-col>
        </el-row>
        <el-form>
          <ValidationObserver
            v-slot="{ passes }"
            ref="observer"
          >
            <el-row
              type="flex"
              :gutter="40"
            >
              <el-col
                id="champsPhoto"
                :span="24"
                :lg="8"
              >
                <el-form-item
                  v-if="loadedFile !== null && loadedFile !== '' && loadedFile !== 'en cours'"
                  label="Photo participante :"
                >
                  <el-image
                    :src="loadedFile"
                  />
                </el-form-item>
                <el-label
                  v-else
                >
                  Photo participante
                </el-label>
                <file-pond
                  ref="pond"
                  name="uploader"
                  :allow-multiple="false"
                  accepted-file-types="image/jpeg, image/png"
                  :allow-file-size-validation="true"
                  :files="myFiles"
                  max-file-size="6MB"
                  @init="handleFilePondInit"
                  @addfilestart="handleAddFileStart"
                  @error="handleError"
                  @removefile="handleRemoveFile"
                  @processfile="handleProcessFile"
                />
                <ValidationProvider
                  v-slot="{ errors }"
                  name="fichier"
                  rules="required"
                  mode="lazy"
                >
                  <el-form-item
                    id="hiddenFile"
                    :error="errors[0]"
                  >
                    <el-input
                      v-model="input.fileInfo"
                      :disabled="saving || underMaintenance"
                      type="hidden"
                      rules="required"
                    />
                  </el-form-item>
                </ValidationProvider>
              </el-col>
              <el-col
                :span="24"
                :lg="16"
              >
                <el-row
                  type="flex"
                  :gutter="20"
                >
                  <el-col
                    :span="24"
                    :md="12"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="nom et prénom"
                      rules="required|max:200"
                      mode="lazy"
                    >
                      <el-form-item
                        label="Nom et prénom *"
                        :error="errors[0]"
                      >
                        <el-input
                          v-model="input.prenomNomClient"
                          :disabled="saving || underMaintenance"
                          type="text"
                        />
                      </el-form-item>
                    </ValidationProvider>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  :gutter="20"
                >
                  <el-col
                    :span="24"
                    :md="12"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="titre de la photo"
                      rules="required|max:200"
                      mode="lazy"
                    >
                      <el-form-item
                        label="Titre de la photo *"
                        :error="errors[0]"
                      >
                        <el-input
                          v-model="input.title"
                          :disabled="saving || underMaintenance"
                          type="text"
                        />
                      </el-form-item>
                    </ValidationProvider>
                  </el-col>
                  <el-col
                    :span="24"
                    :md="12"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="copyright"
                      rules="required|max:200"
                      mode="lazy"
                    >
                      <el-form-item
                        label="Copyright *"
                        :error="errors[0]"
                      >
                        <el-input
                          v-model="input.copyrights"
                          :disabled="saving || underMaintenance"
                          type="text"
                          rules="required|max:200"
                        />
                      </el-form-item>
                    </ValidationProvider>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  :gutter="20"
                >
                  <el-col
                    :span="24"
                    :md="12"
                  >
                    <el-row :gutter="10">
                      <el-col
                        :span="24"
                        :md="input.destination === 'other' ? 12 : 24"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="destination"
                          rules="required"
                          mode="lazy"
                        >
                          <el-form-item
                            label="Destination *"
                            :error="errors[0]"
                          >
                            <el-select
                              v-model="input.destination"
                              placeholder="Destination"
                              :disabled="saving || underMaintenance"
                              filterable
                              @change="() => {
                                if (input.destination !== 'other') {
                                  input.textDestination = ''
                                }
                              }"
                            >
                              <el-option-group>
                                <el-option
                                  value="other"
                                  label="Autre destination"
                                />
                              </el-option-group>
                              <el-option-group>
                                <el-option
                                  v-for="destination in gpp.destinations"
                                  :key="destination.id"
                                  :value="destination.id"
                                  :label="destination.destination.entitled"
                                />
                              </el-option-group>
                            </el-select>
                          </el-form-item>
                        </ValidationProvider>
                      </el-col>
                      <el-col
                        v-if="input.destination === 'other'"
                        :span="24"
                        :md="12"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="destination libre"
                          rules="required|max:200"
                          mode="lazy"
                        >
                          <el-form-item
                            label="Où ? *"
                            :error="errors[0]"
                          >
                            <el-input
                              v-model="input.textDestination"
                              :disabled="saving || underMaintenance"
                              type="text"
                              rules="required|max:200"
                            />
                          </el-form-item>
                        </ValidationProvider>
                      </el-col>
                    </el-row>
                  </el-col>

                  <el-col
                    :span="24"
                    :md="12"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="lieu"
                      rules="required|max:200"
                      mode="lazy"
                    >
                      <el-form-item
                        label="Lieu où a été prise la photo *"
                        :error="errors[0]"
                      >
                        <el-input
                          v-model="input.place"
                          :disabled="saving || underMaintenance"
                          type="text"
                        />
                      </el-form-item>
                    </ValidationProvider>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  :gutter="20"
                >
                  <el-col
                    :span="24"
                    :md="12"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="nom du voyage VERDIÉ VOYAGES"
                      rules="required|max:200"
                      mode="lazy"
                    >
                      <el-form-item
                        label="Nom du voyage VERDIÉ VOYAGES *"
                        :error="errors[0]"
                      >
                        <el-input
                          v-model="input.productHint"
                          :disabled="saving || underMaintenance"
                          type="text"
                          rules="required|max:200"
                        />
                      </el-form-item>
                    </validationprovider>
                  </el-col>

                  <el-col
                    :span="24"
                    :md="12"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="année du voyage"
                      rules="required|numeric|min_value:1950|max_value:2100"
                      mode="lazy"
                    >
                      <el-form-item
                        label="Année du voyage *"
                        :error="errors[0]"
                      >
                        <el-input
                          v-model="input.year"
                          :disabled="saving || underMaintenance"
                          type="text"
                        />
                      </el-form-item>
                    </ValidationProvider>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  :gutter="20"
                >
                  <el-col
                    :span="24"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="description"
                      rules="required|max:2000|min:150"
                      mode="lazy"
                    >
                      <el-form-item
                        label="Description *"
                        :error="errors[0]"
                      >
                        <el-input
                          v-model="input.description"
                          rows="5"
                          type="textarea"
                          resize="none"
                          :disabled="saving || underMaintenance"
                        />
                      </el-form-item>
                    </ValidationProvider>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col
                    v-if="participation && !!participation.id"
                    :span="24"
                    :md="12"
                    class="action-desktop"
                  >
                    <el-button
                      :loading="saving"
                      type="danger"
                      plain
                      @click="() => modals.remove.show = true"
                    >
                      Supprimer cette participation
                      <i class="modals-remove-button-delete-icon el-icon-delete el-icon-right" />
                    </el-button>
                  </el-col>
                  <el-col
                    :md="participation && !!participation.id ? 12 : 24"
                    :span="24"
                    align="left"
                  >
                    <div class="share-submit-buttons-wrapper">
                      <el-tooltip
                        v-if="participation && participation.id"
                        class="action-desktop"
                        content="Partager ma participation"
                        placement="top"
                      >
                        <i
                          class="el-icon-share share-button"
                          @click="() => modals.share.show = true"
                        />
                      </el-tooltip>
                      <el-popover
                        class="action-mobile"
                        placement="top"
                        trigger="click"
                      >
                        <div class="action-mobile-wrapper">
                          <el-button
                            :loading="saving"
                            plain
                            @click="() => modals.share.show = true"
                          >
                            Partager
                            <i class="modals-remove-button-delete-icon el-icon-share el-icon-right" />
                          </el-button>
                          <el-button
                            :loading="saving"
                            type="danger"
                            plain
                            @click="() => modals.remove.show = true"
                          >
                            Supprimer cette participation
                            <i class="modals-remove-button-delete-icon el-icon-delete el-icon-right" />
                          </el-button>
                        </div>
                        <i
                          slot="reference"
                          class="el-icon-more mobile-action-button"
                        />
                      </el-popover>
                      <el-button
                        :loading="saving"
                        type="primary"
                        @click="passes(save)"
                      >
                        {{ participation && participation.id ? 'Enregistrer' : 'Publier' }}
                      </el-button>
                    </div>
                  </el-col>
                  <!--<el-col
                    :span="24"
                    align="right"
                    class="mt-4"
                  >
                    <a
                      href="/grand-prix-photo-2022"
                      target="_blank"
                    >
                      <el-button>
                        Voir les participations
                      </el-button>
                    </a>
                  </el-col>-->
                </el-row>
              </el-col>
            </el-row>
          </ValidationObserver>
        </el-form>
      </el-card>
    </template>
  </div>
</template>

<script>
// Librairies
import { mapGetters } from 'vuex'

import vueFilePond, { setOptions } from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'

// eslint-disable-next-line camelcase
import fr_FR from 'filepond/locale/fr-fr'
import WEBSITE_URLS from '@/services/website-target'

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize
)

export default {
  components: {
    FilePond
  },
  data () {
    return {
      myFiles: [],
      loadedFile: '',
      fileInfo: '',
      input: {},
      saving: false,
      imagePreviewUrl: null,
      imageFileInputErrors: [],
      modals: {
        remove: {
          show: false
        },
        share: {
          show: false
        }
      }
    }
  },

  computed: {
    ...mapGetters(['gpp', 'participation', 'profil', 'underMaintenance', '']),

    gppLink () {
      return this.gpp ? `${WEBSITE_URLS.home}/${this.gpp.slug}`.replace(/([^:]\/)\/+/g, '$1') : null
    },

    participationLink () {
      return this.participation ? `${WEBSITE_URLS.home}/${this.participation.route}`.replace(/([^:]\/)\/+/g, '$1') : null
    },
    getUrlUpload () {
      return this.gpp ? process.env.VUE_APP_GPP_URL + `/${this.gpp.id}`.replace(/([^:]\/)\/+/g, '$1') : null
    },

    encodedParticipationLink () {
      return this.participationLink ? encodeURI(this.participationLink) : null
    }
  },

  created () {
    // Démarre l'indicateur de chargement
    this.$store.commit('startLoading')

    // Récupère les données utilisées par la vue
    Promise.all([
      this.$store.dispatch('getGpp', this.$route.params.id),
      this.$store.dispatch('getSystemStatus'),
      this.$store.dispatch('getUserInfos', { lockStatus: true }),
      this.$store.dispatch('getAgences')
    ])
      .finally(() => {
        // Initialise l'objet correspondant à la saisie dans le formulaire
        this.input = this.participation
          ? {
            ...this.participation,
            prenomNomClient: this.participation.userName,
            file: null,
            fileRequire: false,
            destination: this.participation.textDestination ? 'other' : (this.participation.destination ? this.participation.destination.id : null)
          }
          : {
            title: '',
            prenomNomClient: `${this.profil.prenomClient} ${this.profil.nomClient}`,
            copyrights: `${this.profil.prenomClient} ${this.profil.nomClient}`,
            destination: null,
            fileInfo: '',
            fileRequire: true,
            place: '',
            productHint: '',
            year: '',
            description: '',
            file: null,
            textDestination: ''
          }

        // Initialise l'URL de prévisualisation
        this.loadedFile = this.participation && this.participation.image
          ? `${WEBSITE_URLS.home}/${this.participation.image}`
          : null
        this.input.fileInfo = this.loadedFile

        // Stop l'indicateur de chargement
        this.$store.commit('stopLoading')
      })
  },

  methods: {
    // eslint-disable-next-line handle-callback-err
    handleProcessFile (error, file) {
      this.input.fileInfo = file.serverId
      this.loadedFile = ''
    },
    // eslint-disable-next-line handle-callback-err
    handleAddFileStart (error, file) {
      this.loadedFile = 'en cours'
    },
    // eslint-disable-next-line handle-callback-err
    handleError (error, file) {
      this.loadedFile = null
    },
    // eslint-disable-next-line handle-callback-err
    handleRemoveFile (error, file) {
      this.input.fileInfo = ''
      this.loadedFile = this.participation && this.participation.image
        ? `${WEBSITE_URLS.home}/${this.participation.image}`
        : null
    },
    handleFilePondInit () {
      fr_FR.server = {
        url: this.getUrlUpload,
        process: {
          url: '/uploadPhoto',
          method: 'POST',
          withCredentials: true,
          headers: {},
          timeout: 360000,
          onload: null,
          onerror: null,
          ondata: null
        }
      }
      setOptions(fr_FR)
      setOptions({
        labelMaxFileSizeExceeded: 'Fichier trop lourd. Veuillez faire glisser un autre fichier'
      })
    },
    handeImageClick () {
      const inputWrapper = this.$refs.imageFileInput.$el
      const input = inputWrapper.querySelector('input')

      if (input) {
        input.click()
      }
    },

    handleFileInputChange (e) {
      const inputWrapper = this.$refs.imageFileInput.$el
      const input = inputWrapper.querySelector('input')

      if (input && input.files && input.files[0]) {
        this.imagePreviewUrl = URL.createObjectURL(input.files[0])
        const sizeInMb = (input.files[0].size / (1024 * 1024)).toFixed(2)

        if (sizeInMb >= 2.1) {
          this.imageFileInputErrors = ['La photo soumise est trop volumineuse (maximum 2 Mo)']
        } else {
          this.imageFileInputErrors = []
        }
      } else {
        this.imageFileInputErrors = []
      }
    },

    save () {
      if (this.imageFileInputErrors.length > 0) {
        return
      }

      // Démarre l'indicateur de chargement
      this.saving = true

      const isCreating = !this.participation || !this.participation.id
      // force la mise à vide du champ textDestination si la destination est 'Autre'
      this.input.textDestination = this.input.destination !== 'other' ? '' : this.input.textDestination
      // Exécute l'enregistrement auprès de l'api
      const send = () =>
        this.$store.dispatch('setParticipation', {
          photoContestId: this.$route.params.id,
          payload: Object.assign(
            {
              title: this.input.title,
              copyrights: this.input.copyrights,
              destination: this.input.destination,
              textDestination: this.input.textDestination,
              productHint: this.input.productHint,
              year: Number.parseInt(this.input.year) || -1,
              description: this.input.description,
              prenomNomClient: this.input.prenomNomClient,
              place: this.input.place,
              file: this.input.fileInfo,
              cp: this.profil.codePostal ? this.profil.codePostal.substring(0, 2) : '01'
            },
            this.participation && this.participation.id ? { id: this.participation.id } : {}
          )
        })
          .then(() => {
            // Actualise l'objet correspondant à la saisie dans le formulaire
            this.input = {
              ...this.input,
              ...this.participation,
              file: null,
              destination: this.participation.textDestination ? 'other' : (this.participation.destination ? this.participation.destination.id : null)
            }

            // Envoi une notification
            this.$message({
              duration: 5000,
              message: isCreating ? 'Publication de la participation effectuée avec succès' : 'Modification de la participation effectuée avec succès',
              showClose: true,
              type: 'success'
            })
          })
          .finally(() => {
            // Stop l'indicateur de chargement
            this.saving = false
          })

      send()
    },

    remove () {
      // Démarre l'indicateur de chargement
      this.saving = true

      this.$store.dispatch('removeParticipation', this.$route.params.id)
        .then(() => {
          // Actualise l'objet correspondant à la saisie dans le formulaire
          this.input = {
            title: '',
            prenomNomClient: `${this.profil.prenomClient} ${this.profil.nomClient}`,
            copyrights: `${this.profil.prenomClient} ${this.profil.nomClient}`,
            destination: null,
            place: '',
            productHint: '',
            fileInfo: '',
            year: '',
            description: '',
            file: null
          }

          this.loadedFile = null
          this.imagePreviewUrl = null

          this.$refs.observer.reset()

          // Envoi une notification
          this.$message({
            duration: 5000,
            message: 'Participation supprimée avec succès',
            showClose: true,
            type: 'success'
          })
        })
        .finally(() => {
          // Stop l'indicateur de chargement
          this.saving = false
          this.modals.remove.show = false
        })
    },

    openFacebookShareModal () {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${this.encodedParticipationLink}`,
        'popup',
        'width=600,height=600'
      )
      return false
    }
  }
}
</script>

<style lang="scss">
#champsPhoto .el-form-item {
  margin-bottom: 10px;
}
#champsPhoto .el-label{
  font-size: 14px;
}
#champsPhoto .el-form-item__content:not(.hidden){
  border-radius: 4px;
  padding: 10px;
  background-color: #F1F0EF;
}
#champsPhoto .el-image{
  text-align: center;
  border-radius: 4px;
  width: 100%;
  background-color: #222222;
}
#champsPhoto .el-image__inner{
  max-height: 256px;
  width: auto;
}

#hiddenFile .el-form-item__content{
  background-color: unset !important;
}

.image-preview {
  width: 100%;
  height: 300px;
  border-radius: 5px;
  margin-top: 15px;
  transition: all;
  transition-duration: 250ms;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &-placeholder {
    background-color: #f4f4f4;
    border: 1px dashed lightgray;

    &:hover {
      border: 1px dashed darkgray;
    }
  }

  &-file {
    overflow: hidden;
    background-position: center;
    background-color: black;
    border: 1px solid white;

    > img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }

    &:hover {
      background-color: #f4f4f4;
      border: 1px dashed darkgray;
    }
  }

  &-disabled {
    cursor: not-allowed;
  }
}

.modals-remove {
  &-text {
    word-break: break-word;
  }

  &-button-delete-icon {
    margin-left: 5px;
  }
}

.share-submit-buttons-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.action-desktop {
  display: none;

  @media only screen and (min-width: 992px) {
    display: initial;
  }
}

.action-mobile {
  display: none;

  @media only screen and (max-width: 991px) {
    display: initial;
  }
}

.mobile-action-button {
  font-size: 1.5rem;
  margin-right: 15px;
  margin-top: 5px;
  cursor: pointer;
  transition: color;
  transition-duration: 250ms;
  transform: rotate(90deg);
  transform-origin: center;

  &:hover {
    color: gray;
  }
}

.action-mobile-wrapper {
  display: flex;
  flex-direction: column;

  > button {
    width: 100%;
    margin-left: 0;

    &:last-child {
      margin-top: 10px;
    }
  }
}

.share-button {
  font-size: 2rem;
  margin-right: 20px;
  cursor: pointer;
  transition: color;
  transition-duration: 250ms;

  &:hover {
    color: gray;
  }
}

.modals-share-content-icons {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0;

  > a {
    margin-right: 24px;

    &:last-child {
      margin-right: 0;
    }

    > img {
      height: 48px;
      width: auto;
    }
  }
}

.copy-url {
  &-form {
    margin-top: 10px;
    padding-bottom: 20px;
  }

  &-input {
      width: auto;
      flex-grow: 1;
      margin-right: 1rem;
  }
}

.participation-link {
  margin-left: 15px;
  font-size: 16px;

  @media only screen and (max-width: 991px) {
    margin-left: 0;
  }

  .el-icon--right {
    margin-left: 0;
  }
}

.gpp-header-wrapper {
  display: flex;
  flex-direction: row;

  @media only screen and (max-width: 991px) {
    flex-direction: column;
  }
}

.gpp-intro-wrapper {
  margin-bottom: 10px;
}

.gpp-intro-text {
  font-size: .90rem;
}
</style>
